import { render, staticRenderFns } from "./TalkMsgForLatest.vue?vue&type=template&id=8009af12"
import script from "./TalkMsgForLatest.vue?vue&type=script&lang=js"
export * from "./TalkMsgForLatest.vue?vue&type=script&lang=js"
import style0 from "./TalkMsgForLatest.vue?vue&type=style&index=0&id=8009af12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports